/*
 * @Author: Zhouqi
 * @Date: 2025-12-19 17:30:07
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-22 14:35:19
 */
import * as React from 'react';

const TipIcon: React.FC<React.SVGProps<SVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 10.6V7.35M8 5.01V5M14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8Z"
      stroke="#A4B8FD"
      strokeOpacity="0.51"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default TipIcon;
